export default "__VITE_ASSET__47aa632a__"